module.exports = __webpack_public_path__ + "static/media/engine-yellow.9696536a.svg";